import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AfterViewInit, Component, OnInit } from "@angular/core";
import { AuthService } from "./../services/auth.service";
import { Usuario } from "../models/usuario.model";
import { CriptografiaService } from "../services/criptografia.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-modal-login",
  templateUrl: "./modal-login.component.html",
  styleUrls: ["./modal-login.component.scss"],
})
export class ModalLoginComponent implements OnInit, AfterViewInit {
  public usuario: Usuario;
  formLogin: FormGroup;
  checked = true;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private criptoService: CriptografiaService
  ) {
    this.usuario = new Usuario();
  }

  ngOnInit(): void {
    const codigoLoja = localStorage.getItem("CodigoLoja") ?? "";

    let user_data = {
      cod: localStorage.getItem("CodigoLoja") ?? "",
      email:
        this.criptoService.descriptografar(
          localStorage.getItem("dll") ?? "",
          "MD5"
        ) ?? "",
      senha:
        this.criptoService.descriptografar(
          localStorage.getItem("version") ?? "",
          "MD5"
        ) ?? "",
    };

    this.formLogin = this.fb.group({
      Codigo: [codigoLoja, [Validators.required]],
      Email: [user_data.email ?? "", [Validators.required, Validators.email]],
      Senha: [user_data.senha ?? "", Validators.required],
    });
  }

  ngAfterViewInit(): void {

  }

  check() {
    if (this.checked) {
      this.checked = false;
    } else {
      this.checked = true;
    }
  }

  salvarLogin() {
    localStorage.setItem(
      "dll",
      this.criptoService.criptografar(this.formLogin.value.Email, "MD5")
    );
    localStorage.setItem(
      "version",
      this.criptoService.criptografar(this.formLogin.value.Senha, "MD5")
    );
  }

  fazerLogin() {
    this.authService.fazerLogin(this.formLogin.value);

    if (this.checked === false) {
      localStorage.removeItem("dll");
      localStorage.removeItem("version");
    } else {
      this.salvarLogin();
    }
  }
}
